import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../auth/AuthContext";
import { clearRetryCounts } from "../utils/axiosInstance";
import { resetSessionExpiredGate } from "../utils/sessionExpiredNavigation";
import "../App.css";
import "./SessionEndedScreen.css";

const SessionEndedScreen = () => {
  const navigate = useNavigate();
  const { clearSession } = useContext(AuthContext);

  const handleGoToLogin = () => {
    resetSessionExpiredGate();
    localStorage.clear();
    clearRetryCounts();
    clearSession();
    navigate("/login", { replace: true });
  };

  return (
    <div className="session-ended-screen">
      <div className="session-ended-card">
        <h1>Session ended</h1>
        <p>
          Your session has ended. Please go to the Login page to sign in again.
        </p>
        <button
          type="button"
          className="btn btn-primary"
          onClick={handleGoToLogin}
        >
          Go to Login
        </button>
      </div>
    </div>
  );
};

export default SessionEndedScreen;
